export default {
	'no-materials-to-show': 'لا يوجد مواد للعرض'
}